export const PAGE_CONFIG = {
  name: 'CommonLogWrap',
  config: {
    logConfig: {
      menuId: '',
      pageId: '912001',
      pageName: 'Databrain Page',
      extInfo: 'studio-databrain-page',
      pagePath: '/databrainLink',
    },
  },
  children: [
    {
      name: 'DatabrainLinkIframe',
      props: {
        inheritQueryParams: true,
        defaultIframeHeight: '1000px',
        // 本页开启同源 iframe 内容自适应高度
        autoSize: true,
        embedOptions: {
          hideTopNav: true,
          hideLeftMenu: true,
          hidePageHeader: true,
          hidePageTabs: true,
          hideAgent: true,
          showDetailPageHeader: true,
        },
        studioGameQueryParams: [
          {
            paramName: 'studioUnifiedid',
            gameField: 'unified_edition_id',
          },
          {
            paramName: 'studioGameCode',
            gameField: 'game_code',
          },
        ],
      },
    },
  ],
};
